import i18n from "@/i18n";
import isEmpty from "lodash/isEmpty.js";

export class EntityParamValue {
  /**
   * @param {string} date
   * @param {EntityParamData} data
   */
  constructor(date, data) {
    const value = data.avg || "";
    const hasValue = !!value;
    let list = [];
    const hasEvents = !isEmpty(data.events);

    if (hasValue) {
      list = [
        `${i18n.t("aggregations.avg")}: ${data.avg}`,
        `${i18n.t("aggregations.min")}: ${data.min}`,
        `${i18n.t("aggregations.max")}: ${data.max}`,
        `${i18n.t("aggregations.count")}: ${data.count}`,
      ];

      if (hasEvents && data.events.count > 1) {
        list.push(`Всего задача: ${data.events.count}`);
      }
    }

    this.date = date;
    this.eventsCount = hasEvents;
    this.value = value;
    this.list = list;
  }
}
